import { useRef, useEffect } from 'react';

export const useClickedOutsideOfRef = (onClickedOutsideOf) => {
  const ref = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      onClickedOutsideOf(
        !!(
          ref.current &&
          !ref.current.contains(event.target) &&
          event.target !== document.querySelectorAll('.ui-checkbox') &&
          onClickedOutsideOf
        )
      );
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickedOutsideOf]);

  return ref;
};
